module.exports = __webpack_public_path__ + "fonts/JDSansPro-Medium067bf507f02c23f731b47377359cbb76.woff";